//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Markup.js";
import "../no/DisplayableObject.js";
import "../no/ugmath.js";
let d=[[[0,"Comment",1,0],[0,"PinToScreen",1,0]],[[[],"GetLocation",{R_:{location:''}},0,0],[["location"],"SetLocation",{},1,0],[["location"],"SetLocation1",{},1,0],[[],"GetAnchorPoint",{R_:{anchorPoint:''}},0,0],[["anchorPoint"],"SetAnchorPoint",{},1,0],[["num"],"GetAnchorObjects",{R_:{anchorObjs:"DisplayableObject[]"}},0,0],[["anchorObjs"],"SetAnchorObjects",{},1,0],[["num"],"GetTerminatingObjects",{R_:{terminatingObjs:"DisplayableObject[]"}},0,0],[["terminatingObjs"],"SetTerminatingObjects",{},1,0],[[],"GetParentMarkup",{R_:{markup:"Markup.Markup"}},0,0]],[]];
SPLM.Markup.Element = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Markup.Element";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;